import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const PrivacyPolicy = () => {

  return (
    <div className="termsservice_wrapper privacypolicy_wrapper">
		<div className="otherpage_banner" style={{ backgroundImage: `url(${homeUrl}/assets/img/privacy-policy-bgimg.jpg)`,}}>
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="toptitlebox">
							<div className="breadcrumb_mainsec">
								<ul>
									<li><a href="#">Home</a></li>
									<li><span>Privacy Policy</span></li>
								</ul>
							</div>
							
							<div className="titlesec">
								<h2>Privacy Policy</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			
		<div className="termsservice_mainsec privacypolicy_mainsec">
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="contntbox">
							<p>At CoinViews, your privacy matters to us. By accessing or interacting with our website, you agree to the terms and practices outlined in this Privacy Policy.</p>
							
							<h2>Information We Collect</h2>
							
							<p>We only collect personal data that you voluntarily provide to us. This includes:</p>
							
							<ul>
								<li>Your name and email address, when you:
									
									<ul>
										<li>Subscribe to our newsletter</li>
										<li>Submit a message via our “Contact Us” form</li>
										<li>Leave a comment on any of our blog posts</li>
									</ul>
								</li>
							</ul>
							
							<p>We do not collect any sensitive personal information beyond what is necessary to communicate with you or enhance your experience on our platform.</p>
							
							<h2>How We Use Your Information</h2>
							
							<p>Any data you submit to CoinViews is used solely for the following purposes:</p>
							
							<ul>
								<li>To respond to your queries</li>
								<li>To send periodic updates or newsletters (if subscribed)</li>
								<li>To improve user experience and optimize our content based on general trends</li>
							</ul>
							
							<p>We never sell, rent, trade, or disclose your personal information to third parties. Your data remains confidential and is stored securely.</p>
							
							<h2>Disclosure on Sponsored Articles</h2>
							
							<p>Content tagged as "Sponsored Articles" is part of a paid partnership or promotional collaboration. These articles are not written by our editorial team and should not be interpreted as financial advice or verified news. Readers are advised to evaluate such content independently before making any investment or financial decisions.</p>
							
							<h2>Embedded content from other websites</h2>
							
							<p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.</p>
							
							<p>These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.</p>
							
							<h2>Analytics and Future Use</h2>
							
							<p>In the future, we may use anonymized data (like visitor behavior, content interactions, and reading trends) to analyze our website’s performance. If we request personal data for such purposes, we will always explain the intent and obtain your clear consent before collecting it.</p>
							
							<h2>Unsubscribe Anytime</h2>
							
							<p>You can unsubscribe from our email updates or communications at any time. Simply click the "unsubscribe" link in any of our emails or reach out to us via our Contact Us page for assistance.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
  );
};

export default PrivacyPolicy;